import React from 'react'
import Sherpa, { TYPE_LARGE } from '../../Sherpa/index'
import GaiaLogo, { TYPE_WHITE } from '../../GaiaLogo/index'

export default function Loading () {
  return (
    <div className="interstitial-loading">
      <Sherpa type={TYPE_LARGE} />
      <GaiaLogo type={TYPE_WHITE} />
    </div>
  )
}
